import { state } from './types';

export default {
  [state.IS_LOADING]: false,
  [state.COLLECTION]: {},
  [state.COLLECTION_SUMMARIES]: null,
  [state.FIRST_VISITS]: {},
  [state.LAST_VISITS]: {},
  [state.VISIT_VARIABLE]: 'Visit Event',
  [state.TIMES_BETWEEN_VISITS]: [],
  [state.TIMES_BETWEEN_VISITS_REQUEST_NUM]: 0,
  [state.TIMES_BETWEEN_VISITS_REQUEST_DELAY_SECS]: 0.5,
  [state.NUM_SELECTED_SUBJECTS]: 0,
};
